import { http } from '@/core/http/client'

export const exportSystemLog = () => http.download('/systemLog/export')
